import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { buildHttpParams } from 'app/core/utils/http-util';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { endpoints } from '../../../constants/endpoints';
import { IClientePortfolioListSummary } from '../interfaces/cliente-portfolio-response.interface';
import { IPortfolioFilter } from '../interfaces/portfolio-filter.interface';
import { IPortfolioRequest } from '../interfaces/portfolio-request.interface';
import {
  IPortfolioListResponse,
  IPortfolioResponse
} from '../interfaces/portfolio-response.interface';
import {
  IPortfolio,
  IPortfolioCategoriaDetalhado
} from '../interfaces/portfolio.interface';

@Injectable({
  providedIn: 'root'
})
export class PortfolioApi {
  private apiUrl = `${environment.pathApi}/${endpoints.environment.portfolio}`;
  private apiUrlCliente = `${environment.pathApi}/${endpoints.customer.cliente}`;

  constructor(private http: HttpClient) {}

  loadPortfolioById(id: number): Observable<IPortfolioCategoriaDetalhado> {
    return this.http.get<IPortfolioCategoriaDetalhado>(`${this.apiUrl}/${id}`);
  }

  searchPortfolios(filter: IPortfolioFilter): Observable<IPortfolioResponse> {
    const params = buildHttpParams(filter);
    return this.http.get<IPortfolioResponse>(`${this.apiUrl}`, { params });
  }

  listPortfolios(
    filter?: IPortfolioFilter
  ): Observable<IPortfolioListResponse> {
    const params = buildHttpParams(filter);
    return this.http.get<IPortfolioListResponse>(`${this.apiUrl}/0/list`, {
      params
    });
  }

  update(id: number, dto: IPortfolioRequest): Observable<IPortfolio> {
    return this.http.put<IPortfolio>(`${this.apiUrl}/${id}`, dto);
  }

  create(dto: IPortfolioRequest): Observable<IPortfolio> {
    return this.http.post<IPortfolio>(`${this.apiUrl}`, dto);
  }

  updateSituacao(id: number, situacao: number): Observable<IPortfolio> {
    return this.http.put<IPortfolio>(
      `${this.apiUrl}/${id}/${situacao}/update-situacao`,
      {}
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  fetchClientePortfolioByIdCliente(
    idCliente: number
  ): Observable<IClientePortfolioListSummary[]> {
    return this.http.get<IClientePortfolioListSummary[]>(
      `${this.apiUrlCliente}/${idCliente}/portfolios/list`
    );
  }

  existesClientePortfolioByIdCliente(idCliente: number): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.apiUrlCliente}/${idCliente}/portfolios/exists`
    );
  }
}
